import React from 'react'
import "./Humburger.css"
const Humburger = ({showHumburger,onClick}) => {
  return <>
    
    <div className="humburger-box" onClick={onClick}>
        <div className={`humburger-line ${!showHumburger?'active':''} line1`}></div>
        <div className={`humburger-line ${!showHumburger?'active':''} line2`}></div>
        <div className={`humburger-line ${!showHumburger?'active':''} line3`}></div>
    </div>
  
  </>
}

export default Humburger